import { Link, useLocation } from 'react-router-dom'; 
// import Logo from '../logo/Logo';
import Palette from '../../util/theme/Palette';
import { Squeeze as Hamburger } from 'hamburger-react'
import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import { BP } from '../../util/constants/breakpoints';
import {  useLenis } from 'lenis/react'

export default function NavBar(){

    const { pathname } = useLocation();

    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [drawerHovering, setDrawerHovering] = useState(false);
    const [hovering, setHovering] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const navWrapperRef = useRef(null);
    const navVisible = useInView(navWrapperRef);


    const onWindowWidthChange = () => {
        setIsMobile(isMobileView);
        setDrawerOpen(false);
    }

    const isMobileView = () => {
        if(window.innerWidth < BP.sm) return true;
        else return false;
    }

    useEffect(() => {
        setIsMobile(isMobileView)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const drawerLinkClass = `
        text-navbar-text-light
        dark:text-navbar-text-dark
        text-3xl
        font-normal
        tracking-wider
    `;

    const linkClass = `
        text-navbar-text-light
        dark:text-navbar-text-dark
        text-base
        font-normal
        tracking-wider
    `;

    const drawerListItemClass = `
        flex 
        gap-x-2
        items-center
        my-1
        ml-3
        inline
        w-min
        text-nowrap
    `;

    const listItemClass = `
        flex 
        flex-col
        gap-x-2
        items-center
        my-1
        ml-3
        group
    `;


    const drawerBulletClass = `
        h-3
        w-3
        bg-navbar-text-light
        dark:bg-navbar-text-dark
        rounded-full
        mr-2
    `;

    const bulletClass = `
        h-1.5
        w-1.5
        bg-navbar-text-light
        dark:bg-navbar-text-dark
        rounded-full
        mt-1
    `;

    const navPaths = [
        {
            to: "/Projects",
            displayName: "CRAFTS"
        },
        {
            to: "/AboutMe",
            displayName: "ABOUT"
        },
        {
            to: "/Contact",
            displayName: "GET IN TOUCH"
        },
    ]


    const navListItems = (arr) => {
        let displayArr = [];


        for(let i = 0; i < arr.length; i++){
            const bulletVariants = {
                initial: {scale: (pathname===arr[i].to && !hovering)?1:0},
                animate: { scale: 1}
            }
            displayArr.push(
                <motion.div
                    initial="initial"
                    animate="initial"
                    whileHover="animate"
                    onHoverStart={() => setHovering(true)}
                    onHoverEnd={() => setHovering(false)}
                    key={"navListItem-" + i}
                >
                    <li className={listItemClass}>
                        {
                            (pathname === arr[i].to)?
                            <a href="#top" onClick={() => {setDrawerOpen(false); scrollToTop();}} className={linkClass}>{arr[i].displayName}</a>
                            :
                            <Link to={arr[i].to} className={linkClass}>{arr[i].displayName}</Link>
                        }
                        <motion.div 
                            initial={{
                                scale: 0
                            }}
                            animate={{
                                scale: (pathname===arr[i].to && !hovering)?1:0,
                            }}
                            exit={{
                                scale: 0
                            }}
                            transition={{
                                ease: "backInOut",
                                duration: 0.6,
                            }}
                            variants={bulletVariants}
                            className={bulletClass}
                        />
                    </li>
                </motion.div>
            );
        }

        return displayArr;
    }


    const drawerListItems = (arr) => {
        let displayArr = [];

        for(let i = 0; i < arr.length; i++){

            const bulletVariants = {
                initial: {
                    scale: (pathname===arr[i].to && !drawerHovering)?1:0,
                },
                animate: { 
                    scale: 1,
                },
            }
            displayArr.push(
                <motion.div
                key={"drawerItem-" + i}
                initial={{
                    translateY: "-1000%"
                }}
                animate={{
                    translateY: 0
                }}
                exit={{
                    translateY: "-1000%"
                }}
                transition={{
                    delay: (arr.length - i -1) * 0.1 + 0.5,
                    ease: "circInOut"
                }}
                >
                    <motion.li 
                        className={drawerListItemClass}
                        whileHover="animate"
                        onHoverStart={() => setDrawerHovering(true)}
                        onHoverEnd ={() => setDrawerHovering(false)}
                    >
                        <motion.div 
                            initial={{
                                scale: 0
                            }}
                            animate={{
                                scale: (pathname===arr[i].to && !drawerHovering)?1:0,
                            }}
                            exit={{
                                scale: 0,
                            }}
                            transition={{
                                ease: "backInOut"
                            }}
                            variants={bulletVariants}
                            className={drawerBulletClass}
                        />
                        {
                            (pathname === arr[i].to)?
                            <a href="#top" onClick={() => { setDrawerOpen(false); scrollToTop(); }} className={drawerLinkClass}>{arr[i].displayName}</a>
                            :
                            <Link to={arr[i].to} className={drawerLinkClass}>{arr[i].displayName}</Link>
                        }
                    </motion.li>
                </motion.div>
            );
        }

        return displayArr;
    }

    useEffect(() => {
        setDrawerOpen(false);
    }, [pathname]);


    const lenis = useLenis(()=>{});
    const scrollToTop = () => {
        lenis?.scrollTo("#top");
    }


    return (
        <>

            <div className='absolute top-0' id="top" ref={navWrapperRef}>
                {
                /**------------------------------------------------------------------------
                *                          Desktop Navbar 
                *------------------------------------------------------------------------**/
                }

                {
                    !isMobile && (
                        <>

                            <div
                                className='
                                    flex
                                    justify-between
                                    py-6
                                    px-10
                                    relative
                                    w-screen
                                    bg-navbar-bg-light
                                    dark:bg-navbar-bg-dark
                                    z-30
                                '
                            >
                                    {
                                        (pathname === "/")?
                                        <a 
                                        href="#top" 
                                        onClick={() => {
                                            setDrawerOpen(false);
                                            scrollToTop();
                                        } } 
                                        className="
                                            text-navbar-text-light
                                            dark:text-navbar-text-dark
                                            text-base
                                            font-semibold
                                            tracking-wider
                                            inline
                                        "
                                        >WEI JIAN</a>
                                        :
                                        <Link 
                                            to="/"
                                            className="
                                                text-navbar-text-light
                                                dark:text-navbar-text-dark
                                                text-base
                                                font-semibold
                                                tracking-wider
                                                inline
                                            "
                                        >
                                            WEI JIAN
                                        </Link>
                                    }

                                <nav>
                                    <ul className='flex gap-10'>
                                        {
                                            navListItems(navPaths)
                                        } 
                                    </ul>
                                </nav>
                            </div>


                            {/* Desktop Burger */}
                            <AnimatePresence>
                                {
                                    !navVisible && !isMobile && (
                                        <motion.div
                                            initial={{
                                                scale: 0,
                                            }}
                                            animate={{
                                                scale: 1,
                                            }}
                                            exit={{
                                                scale: 0,
                                            }}
                                            transition={{
                                                ease: "circInOut",
                                                duration: 0.3,
                                            }}
                                            className="
                                                right-5
                                                z-50
                                                top-5
                                                bg-white
                                                drop-shadow
                                                rounded-full
                                                p-2
                                                fixed
                                            "
                                        >
                                            <Hamburger toggled={isDrawerOpen} toggle={setDrawerOpen} size={22} />
                                        </motion.div>
                                    )
                                }
                            </AnimatePresence>

                            {/* Desktop Side Drawer */}
                            <AnimatePresence>
                                {
                                    isDrawerOpen && !isMobile && (
                                        // <SideDrawer />

                                        <motion.div
                                            initial={{
                                                translateX: "100%",
                                            }}
                                            animate={{
                                                translateX: 0,
                                            }}
                                            exit={{
                                                translateX: "100%",
                                            }}
                                            transition={{
                                                ease: "circInOut",
                                                duration: 0.6,
                                            }}
                                            className="
                                                top-0
                                                right-0
                                                w-full
                                                h-screen
                                                fixed
                                                bg-white
                                                no-doc-scroll
                                                flex
                                                flex-col
                                                px-10
                                                pt-28
                                                lg:w-1/3
                                                lg:drop-shadow-md
                                                z-40
                                            "
                                        >
                                            <nav>
                                                <ul>
                                                {
                                                    drawerListItems(navPaths)
                                                }
                                                </ul>
                                            </nav>
                                        </motion.div>


                                    )
                                }
                            </AnimatePresence>
                        {/* /**------------------------------------------------------------------------
                        *                        drawer backdrop 
                        *------------------------------------------------------------------------ */}
                        <AnimatePresence mode="wait">
                            {
                                isDrawerOpen &&  (!isMobile || !navVisible) && (
                                    <motion.div
                                        onClick={ () => {
                                            setDrawerOpen(false)
                                        }}
                                        initial={{
                                            opacity: 0,
                                        }}
                                        animate={{
                                            opacity: "100%",
                                        }}
                                        exit={{
                                            opacity: 0,
                                        }}
                                        transition={{
                                            ease: "circInOut",
                                            duration: 0.6,
                                        }}
                                        className="
                                            top-0
                                            w-full
                                            h-screen
                                            fixed
                                            bg-slate-950/50
                                            z-30
                                        "
                                    />
                                )
                            }
                        </AnimatePresence>


                        </>


                    )
                }

                {
                /**------------------------------------------------------------------------
                *                          Mobile Navbar 
                *------------------------------------------------------------------------**/
                }

                {

                    isMobile && (

                        <>

                        <div 
                            className='
                                flex
                                justify-center
                                py-6
                                relative
                                w-screen
                                bg-navbar-bg-light
                                dark:bg-navbar-bg-dark
                                z-30
                            '
                        >
                            {
                                (pathname === "/")?
                                <a 
                                href="#top" 
                                onClick={() => {
                                    setDrawerOpen(false);
                                    scrollToTop();
                                }} 
                                className="
                                    text-navbar-text-light
                                    dark:text-navbar-text-dark
                                    text-base
                                    font-semibold
                                    tracking-wider
                                    inline
                                "
                                >WEI JIAN</a>
                                :
                                <Link 
                                    to="/"
                                    className="
                                        text-navbar-text-light
                                        dark:text-navbar-text-dark
                                        text-base
                                        font-semibold
                                        tracking-wider
                                        inline
                                    "
                                >
                                    WEI JIAN
                                </Link>
                            }
                            <div className='absolute right-2 top-1/2 -translate-y-1/2'>
                                <Hamburger 
                                    color={Palette.light['black']} 
                                    size={20} 
                                    rounded={true}
                                    toggled={isDrawerOpen}
                                    toggle={setDrawerOpen}
                                />
                            </div>
                        </div>


                        <AnimatePresence>
                            {
                                !navVisible && isMobile && (
                                    <motion.div
                                        initial={{
                                            scale: 0,
                                        }}
                                        animate={{
                                            scale: 1,
                                        }}
                                        exit={{
                                            scale: 0,
                                        }}
                                        transition={{
                                            ease: "circInOut",
                                            duration: 0.3,
                                        }}
                                        className="
                                            right-5
                                            z-30
                                            top-5
                                            bg-white
                                            drop-shadow
                                            rounded-full
                                            p-2
                                            fixed
                                        "
                                    >
                                        <Hamburger toggled={isDrawerOpen} toggle={setDrawerOpen} size={22} />
                                    </motion.div>
                                )
                            }
                        </AnimatePresence>


                        <AnimatePresence>
                            {
                                isDrawerOpen && isMobile && (
                                    <motion.div 
                                    initial={{
                                        translateY: "-100%",
                                        borderBottom: "solid 600px " + Palette.light['secondary']
                                    }}
                                    animate={{
                                        translateY:0,
                                        // borderRadius: [
                                        //     0, 
                                        //     "0% 0% 50% 50% / 70% 70% 30% 30%", 
                                        //     0
                                        // ],
                                        borderBottomWidth: "0"
                                    }}
                                    exit={{
                                        translateY:"-100%",
                                        borderBottomWidth: ["0", "600px", "0"],
                                        // borderBottomWidth: "600px",
                                        borderBottom: "solid " + Palette.light['secondary'],
                                        transition: {
                                            ease: "circInOut",
                                            duration: 0.6,
                                        }
                                    }}
                                    transition={{
                                        ease: "circInOut",
                                        duration: 0.6,
                                        borderRadius: {
                                            delay: 0.097
                                        },
                                        borderBottomWidth: {
                                            delay: 0.4
                                        }

                                    }}
                                    className='
                                        w-screen
                                        h-screen
                                        fixed
                                        bg-navbar-bg-light
                                        dark:bg-navbar-bg-dark
                                        sm:hidden
                                        no-doc-scroll
                                        z-20
                                        top-0
                                        pt-20
                                    '
                                    >
                                        <nav>
                                            <ul>
                                                {
                                                    drawerListItems(navPaths)
                                                }
                                            </ul>
                                        </nav>
                                    </motion.div>
                                )
                            }
                        </AnimatePresence>


                        </>
                    )

                }



            </div>
        </>
    );


}